<template>
    <v-responsive v-bind="$attrs" :class="{ 'grey lighten-2': !url }" class="text-center" @click="click">
        <v-img v-if="url" :src="url" v-bind="$attrs"></v-img>
        <v-layout v-else align-center justify-center fill-height><v-icon>mdi-image</v-icon></v-layout>
        <v-file-input v-model="fileInput" ref="fileInput" accept="image/*" class="d-none" @change="input"></v-file-input>
    </v-responsive>
</template>

<script>
export default {
    props: ["value"],
    data() {
        return {
            file: this.$props.value,
            fileInput: null,
        };
    },
    computed: {
        url() {
            if (this.file instanceof File) return URL.createObjectURL(this.file);
            return this.file?.url;
        },
    },
    watch: {
        value() {
            this.file = this.value;
        },
    },
    methods: {
        input(file) {
            this.file = file;
            this.fileInput = null;
            this.$emit("input", file);
        },
        click() {
            this.$refs.fileInput.$el.getElementsByTagName("input")[0].click();
        },
    },
};
</script>